import { Clickable, Image } from '@ahmdigital/ui';
import { CSSProperties, MutableRefObject, useEffect, useState } from 'react';

import requestCallImage from './images/request-call.svg';
import styles from './styles.module.sass';

type RequestACallMinimizedProps = {
  actions: {
    requestACall: {
      expand: (...args: unknown[]) => unknown;
    };
  };
  cmsAnnouncementBannerRef?: MutableRefObject<HTMLDivElement | null>;
};

type MinimizedButtonStyle = CSSProperties & {
  '--cms-announcement-banner-height'?: string;
};

const RequestACallMinimized = ({ actions, cmsAnnouncementBannerRef }: RequestACallMinimizedProps) => {
  const [cmsAnnouncementBannerHeight, setCmsAnnouncementBannerHeight] = useState(0);

  useEffect(() => {
    const element = cmsAnnouncementBannerRef?.current;

    if (!element) {
      setCmsAnnouncementBannerHeight(0);
      return undefined;
    }

    const updateHeight = () => setCmsAnnouncementBannerHeight(element.offsetHeight);

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [cmsAnnouncementBannerRef]);

  const minimizedButtonStyle: MinimizedButtonStyle = {
    '--cms-announcement-banner-height': `${cmsAnnouncementBannerHeight}px`,
  };

  return (
    <div style={minimizedButtonStyle}>
      <Clickable isUnstyled onClick={actions.requestACall.expand} variant={styles.minimizedButton}>
        <Image src={requestCallImage.src} className={styles.image} alt="speech bubble that says 'get a call back'" />
        <div className={styles.visuallyHidden}>Get a call back</div>
      </Clickable>
    </div>
  );
};

export default RequestACallMinimized;
